import Request from './request'

const Reports  = {
  getReports(params, callback) {
    return Request.get('reports/index', params).then(callback).catch(this.bad_answer)
  },
  getReportInfo(id, callback) {
    return Request.get('reports/view/' + id).then(callback).catch(this.bad_answer)
  },
  createReports(params, callback) {
    return Request.post('reports', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}

export default Reports
